import { error } from "highcharts";
import { types } from "./action";

const initialState = {
  list: [],
  error: null,
  loaded: false,
  total: null,
  filterList: null,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.DATA_POINT_LIST: {
      return {
        ...state,
        loaded: false,
      };
    }
    case types.DATA_POINT_LIST_SUCCESS: {
      return {
        ...state,
        loaded: true,
        list: action.payload?.list,
        total: action.payload?.total,
        filterList: action.payload?.filterList,
      };
    }
    case types.DATA_POINT_LIST_FAILED: {
      return {
        ...state,
        loaded: true,
        error: action.payload,
      };
    }
    case types.LOAD_MORE_DATAPOINT_SUCCESS: {
      return {
        ...state,
        list: [...state.list, ...(action.payload?.list || [])],
        filterList: action.payload?.filterList,
      };
    }
    case types.LOAD_MORE_DATAPOINT_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }

    case types.CLEAR_DATA_POINT_LIST: {
      return { ...initialState };
    }
    default:
      return state;
  }
}
